var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99521 3.07565C5.59566 1.39189 3.26182 0.938959 1.50829 2.48078C-0.245249 4.0226 -0.492123 6.60045 0.884939 8.42397C2.02987 9.94011 5.49484 13.1377 6.63047 14.1727C6.75752 14.2885 6.82105 14.3464 6.89515 14.3691C6.95982 14.389 7.03059 14.389 7.09526 14.3691C7.16936 14.3464 7.23289 14.2885 7.35994 14.1727C8.49557 13.1377 11.9605 9.94011 13.1055 8.42397C14.4825 6.60045 14.2658 4.00639 12.4821 2.48078C10.6984 0.955177 8.39475 1.39189 6.99521 3.07565Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheart);
export default __webpack_public_path__ + "static/media/wheart.73718aca6360a6845b98223cc53351a2.svg";
export { ForwardRef as ReactComponent };